// extracted by mini-css-extract-plugin
export default {"about_location":"Location_about_location__aLRzC","text_box":"Location_text_box__3DCR7","map_image":"Location_map_image__RPxz6"};